// -------------------------------------------------------------------< constants >-------------------------------------------------------------------
const GET_SELF_SERVICES_REQUESTS_SUCCESS = 'GET_SELF_SERVICES_REQUESTS_SUCCESS';
const GET_SELF_SERVICE_REQUESTS_SUCCESS = 'GET_SELF_SERVICE_REQUESTS_SUCCESS';

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------
/**
 *
 * @param {*} payload
 * @return {{type: string, payload: *}}
 */
function _getRequestSelfServicesSuccess(payload) {
  return {
    type: GET_SELF_SERVICES_REQUESTS_SUCCESS,
    payload: payload.data,
  };
}/**
 *
 * @param {*} payload
 * @return {{type: string, payload: *}}
 */
function _getRequestSelfServiceSuccess(payload) {
  return {
    type: GET_SELF_SERVICE_REQUESTS_SUCCESS,
    payload: payload.data,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------
/**
 * @param {object} params
 * @param {function} callback
 * @return {Function}
 */
export function getRequestSelfServices(params = {}, callback = (r) => {
}) {
  return (dispatch, gs, api) => {
    api.get(`/feeding/self_service`, {params})
      .then((r) => {
        dispatch(_getRequestSelfServicesSuccess(r));
        callback(r);
      })
      .catch((e) => {
      });
  };
}/**
 * @param {number} selfServiceId
 * @param {object} params
 * @param {function} callback
 * @return {Function}
 */
export function getRequestSelfService(selfServiceId, params = {}, callback = (r) => {
}) {
  return (dispatch, gs, api) => {
    api.get(`/feeding/self_service/${selfServiceId}`, {params})
      .then((r) => {
        dispatch(_getRequestSelfServiceSuccess(r));
        callback(r);
      })
      .catch((e) => {
      });
  };
}

/**
 *
 * @return {{type: string, payload: *}}
 */
export function emptyRequestSelfServices() {
  return _getRequestSelfServicesSuccess({data: {selfServices: []}, meta: {}});
}
/**
 *
 * @return {{type: string, payload: *}}
 */
export function emptyRequestSelfService() {
  return _getRequestSelfServiceSuccess({data: {selfService: {}}, meta: {}});
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {object} state
 * @param {object} action
 * @return {object}
 */
export default function reducer(state = {
  selfServices: [],
  selfService: {},
}, action) {
  switch (action.type) {
    case GET_SELF_SERVICES_REQUESTS_SUCCESS:
      return Object.assign({}, state, {
        selfServices: action.payload.selfServices,
      });
    case GET_SELF_SERVICE_REQUESTS_SUCCESS:
      return Object.assign({}, state, {
        selfService: action.payload.selfService,
      });
    default:
      return state;
  }
}
